import { LanguageKey } from '../../SDK/Language';
import { IDataSet } from '../Track';
import { Platform } from '../DDNA';

export class MetaDataSet implements IDataSet {
    public gameVersion: string = undefined;
    public gameID: string = undefined;
    //public platformUserID: string = undefined;
    //public timezoneOffset: string = undefined;
    //public timezoneName: string = undefined;
    public platform: Platform = undefined;
    public deviceType: string = undefined;
    public operatingSystem: string = undefined;
    public operatingSystemVersion: string = undefined;
    public screenHeight: number = undefined;
    public screenWidth: number = undefined;
    public frameRate: number = undefined;
    public durationSinceJSEnabled: number = undefined;
    public loadingTime: number = undefined;
    public userLocale: LanguageKey = undefined;
    //public country: string = undefined;

    // Duplicate of `durationSinceJSEnabled`?
    //public timeSinceJSEnabled: number = undefined;

    public musicIsOn: boolean = undefined;
    public soundIsOn: boolean = undefined;

    //public error: string = undefined;

    public changerBooster: number = undefined;
    public removeOneBooster: number = undefined;
    public massRemoveBooster: number = undefined;
    public jokerBooster: number = undefined;
    public coins: number = undefined;
    public lives: number = undefined;
    public stars: number = undefined;
    public keysKeyHunt: number = undefined;
    public realMoneyPurchasesMade: number = 0;

    public timeToNextLife: number = undefined;

    public activeCardSet: string = undefined;

    public lastLevelAttempted: number = undefined;
    public lastLevelWon: number = undefined;
    public sessionNum: number = undefined;
    public activeMap: string = undefined;
    public highestLevel: number = undefined;
}
